import { Component, Input, OnDestroy, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription } from 'rxjs/Subscription';

import {
  CanComponentDeactivate,
  EntityService,
  ModalService,
  ToastService,
  MessageService
} from '../../core';
import { SurveyService } from "../shared/survey.services";
import { SurveyConfig, ResultSurvey } from "../shared/survey.model";
import { Validators } from "@angular/forms";
//import { DynamicFormComponent } from "app/core/dynamic-form/containers/dynamic-form/dynamic-form.component";
//import { FieldConfig } from "app/core/dynamic-form/models/field-config.interface";

@Component({
  moduleId: module.id,
  selector: 'bp-survey-result',
  templateUrl: './survey-result.component.html',
})

export class SurveyResultComponent implements OnDestroy, OnInit, AfterViewInit {

  @Input()
  surveyResult: ResultSurvey;
  surveyGraphsData: any[] = [];
  constructor(
    private entityService: EntityService,
    private modalService: ModalService,
    private route: ActivatedRoute,
    private router: Router,
    private surveyServices: SurveyService,
    private toastService: ToastService) { }


  ngOnInit() {

    let noOfQuestions = this.surveyResult.surveyQuestions.length;
    for (let i = 0; i < noOfQuestions; i++) {
      let question = this.surveyResult.surveyQuestions[i];

      let data = {
        labels: [] = [],
        datasets: [] = [],
        options: {} = {}
      };

      data.options = {
        responsive: true,
        legend: false,
        title: {
          display: true,
          text: question.questionText
        },
        scales: {
          xAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 1,
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
            },
            barThickness: 20,
          }]
        }
      }

      let noOfAnswers = question.answers.length;

      let datasetAnswers = {
        //type: 'bar',
       // label: [],
        borderWidth: 1,
        backgroundColor: "rgba(255,177,193,0.5)",
        data: [] = [],
      };

      for (let k = 0; k < noOfAnswers; k++) {
        let answer = question.answers[k];
        data.labels.push(answer.answerText);
        datasetAnswers.data.push(answer.selectionCount);
      }

      data.datasets = [datasetAnswers];

      this.surveyGraphsData.push(data);
    }

  }
  ngAfterViewInit() {
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/app/surveys/survey-result/survey-result.component.ts